<!-- ! DINAMICO -->
<ng-container *ngIf="promo.TipoPromocion === 'DINAMICO'">
  <ion-label
    mode="md"
    color="tpcta"
    class="ion-text-center mpe-font-weight-600"
    [attr.data-test]="'Automation.txt-promocard-discover' | translate"
  >
    {{ "Labels.discover-discount" | translate }}
  </ion-label>
</ng-container>

<!-- ! ESCALERA -->
<ng-container *ngIf="promo.TipoPromocion === 'ESCALERA'">
  <ion-label mode="md" class="label-ladder">
    <ion-text mode="md" color="grayDemon" class="save-up-to">
      {{ "Labels.save-up-to" | translate }}
    </ion-text>

    <ion-text
      color="tpcta"
      class="mpe-font-weight-600 discount-stairs ion-float-right"
    >
      {{ promo.PrecioOriginal | percent : "1.0-2" }}
    </ion-text>
  </ion-label>
</ng-container>

<!-- ! ESTATICO -->
<ng-container *ngIf="promo.TipoPromocion === 'ESTATICO'">
  <ion-label mode="md" class="ion-text-end">
    <ion-text mode="md" color="danger" class="precio-descuento" [attr.data-test]="'Automation.btn-promocard-discountprice' | translate">
      <del>{{ promo.PrecioOriginal | currency }}</del>
    </ion-text>
    <ion-text
      mode="md"
      color="tpcta"
      class="precio-original mpe-font-weight-600"
      [attr.data-test]="'Automation.btn-promocard-originalprice' | translate"
    >
      {{ promo.PrecioDescuento | currency }}
    </ion-text>
  </ion-label>
</ng-container>

<!-- ! BONIFICACION -->
<ng-container *ngIf="promo.TipoPromocion === 'BONIFICACION'">
  <ion-label mode="md" color="cadet-grey" class="product">
    {{ "Labels.product" | translate }}
    <ion-text color="tpcta" class="ion-float-right mpe-font-weight-600 free">
      {{ "Labels.free" | translate }}
    </ion-text>
  </ion-label>
</ng-container>
